import styled from 'styled-components';
import { DASHBOARD_STYLED_CONSTS } from '@components';
import { mediaQueries } from '@fourthwall/components';
export const AnalyticsTableWrapper = styled.div `
  position: sticky;
  top: calc(${DASHBOARD_STYLED_CONSTS.NAVBAR_HEIGHT}px + var(--space-500));

  #analytics-table {
    max-height: calc(100vh - ${DASHBOARD_STYLED_CONSTS.NAVBAR_HEIGHT}px - var(--space-500) * 2);
  }

  ${mediaQueries.tablet} {
    top: calc(${DASHBOARD_STYLED_CONSTS.HEADER_HEIGHT}px + var(--space-500));

    #analytics-table {
      max-height: calc(100vh - ${DASHBOARD_STYLED_CONSTS.HEADER_HEIGHT}px - var(--space-500) * 2);
    }
  }
`;
export const ToolbarContent = styled.div `
  display: flex;
  align-items: center;
  gap: var(--space-200);

  ${mediaQueries.laptop} {
    display: none;
  }
`;
export const Actions = styled.div `
  display: none;

  ${mediaQueries.laptop} {
    display: contents;
  }
`;
export const HeaderSkeleton = styled.div `
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: var(--space-600);
`;
